import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MedicineCatModal } from 'app/EMR/DoctorModels/medicineCategory.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LocationService } from 'app/masters/location-master/location.service';
import { EMRService } from 'app/EMR/EMR.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { MatTableDataSource } from '@angular/material/table';
import { ExportService } from 'app/reports/services/export.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-medicine-catgeory-master',
  templateUrl: './medicine-catgeory-master.component.html',
  styleUrls: ['./medicine-catgeory-master.component.scss']
})
export class MedicineCatgeoryMasterComponent implements OnInit {

  destroy$: Subject<boolean> = new Subject<boolean>();

  private addmedicinecategory: MedicineCatModal = {};
  filteredMedicineCategoryMainarray: any = []; 
  private fontfamilyArray: any = [];
  private showspinner: boolean = false;
  // private medicinecategories_ds: any = new MatTableDataSource<MedicineCatModal>();
  displayedColumns_medinicecategories: string[] = ['medicineCatName'];
  medicineCategoryMainarray: any = [];
  searchValue: string;
  dataSource = new MatTableDataSource<any>();
  popbutton: number;
  constructor(private emrService: EMRService, private dashboardService: DashboardService , private exportdata: ExportService,
       public dialog: MatDialog,
        public dialogRef: MatDialogRef<MedicineCatgeoryMasterComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }
  ngOnInit(): void {
    this.GetMedicineCategoryMaster(0)
    this.dataSource.filterPredicate = this.createFilter();
    this.popbutton = 0;
    if (this.data.id != null && this.data.id != undefined) {
      this.popbutton = this.data.id;
    }
  }

  selectCategorylist(row) {
    this.addmedicinecategory = row;
    document.getElementById("medicinecategoryModal").style.display = "none";
  }


  addUpdateCategory(event) {
    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
    setTimeout(function () {
      button.removeAttribute('disabled');
    },2000);
    this.showspinner = true;
    if (this.addmedicinecategory.pK_MedicineCategoryId == 0 || !this.addmedicinecategory.pK_MedicineCategoryId) {
      const existingCategory = this.medicineCategoryMainarray.filter(category =>
        category.medicineCategory.toLowerCase() == this.addmedicinecategory.medicineCategory.toLowerCase()
      );
      if (existingCategory.length > 0) {
        this.dashboardService.openSnackBar("Already exists in the list", "OK");
        this.clearForm();
        this.showspinner = false;
        return;
      }
    }
    let payload = {
      "MedicineCategoryMaster":
      {
        "IsEdit": this.addmedicinecategory.pK_MedicineCategoryId ? true : false, "IsDelete": false, "PK_MedicineCategoryId": this.addmedicinecategory.pK_MedicineCategoryId ? this.addmedicinecategory.pK_MedicineCategoryId : 0,
        "MedicineCategory": this.addmedicinecategory.medicineCategory, "IsActive": this.addmedicinecategory.isActive ? this.addmedicinecategory.isActive : false
      }
    }
    this.emrService.InsertMedicineCategoryMaster(payload).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
      if (this.addmedicinecategory.pK_MedicineCategoryId > 0) {
        this.dashboardService.openSnackBar("Record updated successfully", "OK");
      } else {
        this.dashboardService.openSnackBar("Record saved successfully", "OK");
      }
      this.GetMedicineCategoryMaster(0);
      this.addmedicinecategory = {};
      this.showspinner = false;
      if(this.popbutton >0){
        this.closedailog()
      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
      this.showspinner = false;
      this.dashboardService.openSnackBar("API Failed :" + err.status + " Internal Server Error", "OK");
      if(this.popbutton >0){
        this.closedailog()
      }
    });
  }


  openmedicinecatgeoryModal() {
    document.getElementById("medicinecategoryModal").style.display = 'block';
    this.GetMedicineCategoryMaster(0);
  }

  closemedicinecategoryModal() {
    document.getElementById("medicinecategoryModal").style.display = 'none';
    this.searchValue=''
    this.dataSource.filter= ''
  }

  GetMedicineCategoryMaster(medcineid) {
    this.medicineCategoryMainarray = [];
    this.emrService.GetMedicineCategoryMaster(medcineid).pipe(takeUntil(this.destroy$)).subscribe(data => this.successCategory(data), err => this.failed_category(err))
  }

  successCategory(data) {
    this.medicineCategoryMainarray = data;
    this.dataSource.data =data
  }
  failed_category(err) {
    console.error('Failed to fetch medicine categories', err);
    this.dashboardService.openSnackBar("API Failed :" + err.status + " Internal Server Error", "OK");
  }

  clearForm() {
    this.addmedicinecategory = {};
  }



  exportexcel(type: any, ctype: any): void {
    this.exportdata.open_loader_Dialogtwo();
    let element = document.getElementById(ctype);
    this.exportdata.Newexportxcel(element, type);
  }
 
  applymedicinecategoryFilter(searchTerm: string) {
    this.dataSource.filter = searchTerm.trim().toLowerCase();
  }

  createFilter(): (data: any, filter: string) => boolean {
    return (data, filter): boolean => {
      const transformedFilter = filter.trim().toLowerCase();
      return (
        data.medicineCategory?.toLowerCase().includes(transformedFilter) ||
        (data.isActive ? 'active' : 'inactive').includes(transformedFilter)
      );
    };
  }
  closedailog() {
    this.dialogRef.close();
  }
}




